import {
  mapSuccessFormActionsToWidgetActions,
  mapSuccessWidgetActionsToFormActions
} from './actions'
import {
  mapFormTriggersToWidgetTriggers,
  mapWidgetTriggersToFormTriggers
} from './triggers'
import { formToWidget } from './form-to-widget'
import { widgetToForm } from './widget-to-form'

export {
  mapSuccessFormActionsToWidgetActions,
  mapSuccessWidgetActionsToFormActions,
  mapFormTriggersToWidgetTriggers,
  mapWidgetTriggersToFormTriggers,
  formToWidget,
  widgetToForm
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/index.js